import {
    createPinia
} from 'pinia';
const pinia = createPinia();

export default pinia;
export * from './modules/useAuthStore';
export * from './modules/useMainStore';